import { render, staticRenderFns } from "./ImportProductsExcelTab.vue?vue&type=template&id=015a9ff6"
import script from "./ImportProductsExcelTab.vue?vue&type=script&lang=js"
export * from "./ImportProductsExcelTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports